import { _ as _defineProperty } from './helpers-d639255d.js';
import { B as BaseComponentMixin, n as normalizeComponent, b as registerComponent, u as use } from './plugins-4295ce0e.js';
import { C as CheckRadioMixin } from './CheckRadioMixin-51125787.js';

/**
 * Select an option from a set
 * @displayName Radio
 * @example ./examples/Radio.md
 * @style _radio.scss
 */

var script = {
  name: 'ORadio',
  mixins: [BaseComponentMixin, CheckRadioMixin],
  props: {
    rootClass: String,
    disabledClass: String,
    checkClass: String,
    labelClass: String,
    sizeClass: String,
    variantClass: String
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.computedClass('radio', 'rootClass', 'o-radio'), _defineProperty({}, "".concat(this.computedClass('radio', 'sizeClass', 'o-size-')).concat(this.size), this.size), _defineProperty({}, this.computedClass('radio', 'disabledClass', 'o-radio-disabled'), this.disabled)];
    },
    checkClasses: function checkClasses() {
      return [this.computedClass('radio', 'checkClass', 'o-radio-check'), _defineProperty({}, "".concat(this.computedClass('radio', 'variantClass', 'o-color-')).concat(this.variant), this.variant)];
    },
    labelClasses: function labelClasses() {
      return [this.computedClass('radio', 'labelClass', 'o-radio-label')];
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "label",
    {
      ref: "label",
      class: _vm.rootClasses,
      attrs: { disabled: _vm.disabled },
      on: {
        click: _vm.focus,
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault();
          return _vm.$refs.label.click()
        }
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.computedValue,
            expression: "computedValue"
          }
        ],
        ref: "input",
        attrs: {
          type: "radio",
          disabled: _vm.disabled,
          required: _vm.required,
          name: _vm.name
        },
        domProps: {
          value: _vm.nativeValue,
          checked: _vm._q(_vm.computedValue, _vm.nativeValue)
        },
        on: {
          click: function($event) {
            $event.stopPropagation();
          },
          change: function($event) {
            _vm.computedValue = _vm.nativeValue;
          }
        }
      }),
      _vm._v(" "),
      _c("span", { class: _vm.checkClasses }),
      _vm._v(" "),
      _c("span", { class: _vm.labelClasses }, [_vm._t("default")], 2)
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, __vue_component__);
  }
};
use(Plugin);

export default Plugin;
export { __vue_component__ as ORadio };
